import React from "react"

import CustomVideoPlayer from "./CustomVideoPlayer"
import { CloudinaryVideo } from "@cloudinary/url-gen"

const CustomCloudinaryVideoPlayer = ({
  videoFilename,
  posterImageUrl = null,
}) => {
  const videoObj = new CloudinaryVideo(videoFilename.split(".")[0], {
    cloudName: process.env.CLOUDINARY_NAME,
  })
  const baseVideoUrl = videoObj.toURL()
  const posterImagePath = posterImageUrl || videoObj.format("jpg").toURL()

  const sources = [
    { src: baseVideoUrl.replace("?", ".webm?"), type: "video/webm" },
    { src: baseVideoUrl.replace("?", ".mp4?"), type: "video/mp4" },
    { src: baseVideoUrl.replace("?", ".ogv?"), type: "video/ogg" },
  ]

  return (
    <div className="aspect-video w-full">
      <CustomVideoPlayer
        className="aspect-video"
        sources={sources}
        posterImageUrl={posterImagePath}
      />
    </div>
  )
}

export default CustomCloudinaryVideoPlayer
